export default __webpack_public_path__ + "static/media/emoji-gray.efbaf6f3.svg";